import React, { Component } from 'react';
import { StaggeredMotion, spring } from 'react-motion';
import range from 'lodash.range';
import { connect } from 'react-redux';
import Closed from '../../containers/Closed'
import Node from '../nodes/Node'
import { Line } from 'react-lineto';
import { closeNode } from '../../actions';
import {
  positionX, positionY, angleNumber, numberOfNodes, parentNumber, angleValue
  } from '../../common/node'

export class ClosingChildNodes extends Component {

  componentDidMount() {
    const { dispatch, id, parent, server, root } = this.props
    if(typeof server.children[id] === 'undefined' || String(server.children[id]) === ''){
      dispatch(closeNode(id, parent, root))
    }
  }

  render() {
    const { id, client, server, parent, page, root } = this.props
    const _numberOfNodes = numberOfNodes(page, server.children[id], root)
    const parentAngle = angleValue(client.x[parent], client.y[parent],
      client.x[parentNumber(parent)], client.y[parentNumber(parent)])
    const _angleNumber = angleNumber(page, server.children[id], root)

    if(_numberOfNodes === 1) {
      return ( <Closed flag={0} id={id} parent={parent} root={root} /> )
    }
    return (
      <div>
        <StaggeredMotion
          defaultStyles={range(_numberOfNodes).map(() => ({t: 240, o: 1}))}
          styles={
            prevInterpolatedStyles => prevInterpolatedStyles.map((style, i) => {
              if (i === 0) {
                if (_numberOfNodes === 1 && style.t <= 5) {
                  return { t: spring(0, { stiffness: 200, damping: 30 }), o: 0 };
                }
                return { t: spring(0, { stiffness: 200, damping: 30 }), o: 1 };
              }
              if (prevInterpolatedStyles[i - 1].t < 200) {
                if (i === (_numberOfNodes-1) && style.t <= 5) {
                  return { t: spring(0, { stiffness: 200, damping: 30 }), o: 0 };
                }
                return { t: spring(0, { stiffness: 200, damping: 30 }), o: 1 };
              }
              return { t: 240, o: 1 };
            })
          }>
          {interpolatingStyles =>
            <div>
              {interpolatingStyles.map((style, i) =>
                <div>
                  { (i === (_numberOfNodes-1) && (page+_numberOfNodes) < server.children[id].length )
                      ?(
                        <Node
                          x={positionX(style.t, parentAngle + (Math.PI/_angleNumber*(i+1)))+client.x[parent]}
                          y={positionY(style.t, parentAngle + (Math.PI/_angleNumber*(i+1)))+client.y[parent]}
                          key={parent+'.'+i} parent={parent}
                          number={parent+'.'+i}
                          id={id} page={page+_numberOfNodes-1} />
                      )
                      :(
                        <Node
                          x={positionX(style.t, parentAngle + (Math.PI/_angleNumber*(i+1)))+client.x[parent]}
                          y={positionY(style.t, parentAngle + (Math.PI/_angleNumber*(i+1)))+client.y[parent]}
                          key={parent+'.'+i} parent={parent}
                          number={parent+'.'+i} page={page}
                          id={server.children[id][i+page]}/>
                      )
                  }
                  { (style.o === 0)
                    ? (<Closed id={id} parent={parent} root={root} />)
                    : (null)
                  }
                </div>
              )}
            </div>
          }
        </StaggeredMotion>
        { (root)
            ? (null)
            : (
              <Line x0={client.x[parent]+75} y0={client.y[parent]+75}
                x1={client.x[parentNumber(parent)]+75} y1={client.y[parentNumber(parent)]+75}
                border='1px solid #D5D5D5' zIndex={-1} />
            )
        }
      </div>
    )
  }
}

const mapStateToProps = state => ({
  client: state.client,
  server: state.server
});

export default connect(mapStateToProps)(ClosingChildNodes);



// WEBPACK FOOTER //
// ./src/components/animations/ClosingChildNodes.js